import { render, staticRenderFns } from "./ipasasJaPermissions.vue?vue&type=template&id=68ab6fce&scoped=true&"
import script from "./ipasasJaPermissions.vue?vue&type=script&lang=js&"
export * from "./ipasasJaPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ipasasJaPermissions.vue?vue&type=style&index=0&id=68ab6fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab6fce",
  null
  
)

export default component.exports